export type Locale = 'cs' | 'sk' | 'pl' | 'hu' | 'ro' | 'de' | 'at' | 'fr' | 'it' | 'ch'

// TODO convert to enum
export const LocaleEnum: Record<string, Locale> = {
  CZ: 'cs',
  SK: 'sk',
  PL: 'pl',
  HU: 'hu',
  RO: 'ro',
  DE: 'de',
  AT: 'at',
  FR: 'fr',
  IT: 'it',
  CH: 'ch'
}
